import IconMenu from "@mui/icons-material/Menu";
import IconSettings from "@mui/icons-material/Settings";
import IconButton from "@mui/material/IconButton";
import { Link } from "@tanstack/react-router";
import { useState } from "react";
import AppBarDrawer from "./Drawer";

interface AppBarRightIconProps {
	hideSetting?: boolean;
}

function AppBarRightIcon(props: AppBarRightIconProps) {
	const { hideSetting = false } = props;
	const [isOpenDrawer, setOpenDrawer] = useState(false);
	const container = document.getElementById("wrapper") as Element;
	return (
		<>
			{!hideSetting ? (
				<Link to="/dashboard/accounts">
					<IconButton color="primary">
						<IconSettings className="text-default" />
					</IconButton>
				</Link>
			) : null}
			<IconButton color="primary" onClick={() => setOpenDrawer(true)}>
				<IconMenu className="text-default" />
			</IconButton>
			{isOpenDrawer ? (
				<AppBarDrawer
					open={isOpenDrawer}
					container={container}
					onClose={() => setOpenDrawer(false)}
				/>
			) : null}
		</>
	);
}

export default AppBarRightIcon;
